<template>
  <div :class="$style.page">
    <Loading :loading="loading" :text="loadingText">
      <Title title="企业认证">
        <template v-slot:actions>
          <span :class="$style.goBack" @click="goBack">返回</span>
        </template>
      </Title>

      <Row>
        <Item title="企业名称">
          <el-input v-model.trim="company" />
        </Item>

        <Button type="primary" size="small" @click="searchCompany(1)">
          搜索
        </Button>
        <Button type="blue" @click="setVisible(true)"> 添加企业认证 </Button>
      </Row>

      <Divider />

      <!-- 搜索结果 -->
      <Title title="搜索结果" :count="total" />

      <el-table
        :data="showList"
        :fit="true"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="序号" width="30" align="center">
          <template slot-scope="scope">
            {{ limit * (page - 1) + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="companyName"
          label="企业名称"
          width="120"
          align="center"
        />

        <el-table-column
          prop="createdTime"
          label="证件类型"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            {{ getType(scope.row.type) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="cardNum"
          label="证件号码"
          width="120"
          align="center"
        />

        <el-table-column
          prop="createdTime"
          label="提交时间"
          width="120"
          align="center"
        />

        <el-table-column label="状态" width="50" align="center">
          <template slot-scope="scope">
            {{ mapStatus[scope.row.status] }}
          </template>
        </el-table-column>

        <el-table-column
          prop="expireTime"
          label="操作"
          width="50"
          align="center"
        >
          <template slot-scope="scope">
            <span
              :class="$style.action_btn"
              @click="deleteCompany(scope.row.cardId)"
            >
              删除
            </span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="page"
        :page-size="limit"
        :total="total"
        @current-change="loadMorePage"
      />
    </Loading>

    <CompanyPopup
      :visible="visible"
      @close="setVisible(false)"
      @success="searchCompany"
    />
  </div>
</template>

<script>
import { getCertifyCompany, deleteCertifyCompany } from "@server";
import { COMPANY_TYPE_LIST } from "@constant";

import CompanyPopup from "./certify/CompanyPopup.vue";

export default {
  name: "CertifyCompany",
  components: {
    CompanyPopup,
  },
  data() {
    return {
      company: "",

      page: 1,
      limit: 10,
      showList: [],
      total: 0,

      loading: false,
      loadingText: "加载中...",
      visible: false,

      mapStatus: {
        0: "认证中",
        1: "认证成功",
        2: "认证失败",
      },
    };
  },
  methods: {
    async searchCompany(page = 1) {
      this.loadingText = "加载中...";
      this.loading = true;
      this.page = page;

      const params = {
        limit: this.limit,
        page,
      };
      this.company && (params.name = this.company);
      const res = await getCertifyCompany(params);
      const { code, data } = res;

      if (code === 200) {
        this.showList = data.list;
        this.total = data.total;
      }

      this.loading = false;
    },

    async deleteCompany(id) {
      this.$confirm("确定要删除这条企业认证吗？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loadingText = "删除中...";
          this.loading = true;

          const res = await deleteCertifyCompany(id);
          if (res.code === 200) {
            this.$message({ message: "删除成功!", type: "success" });
            this.searchCompany();
          }
          this.loading = false;
        })
        .catch(() => {});
    },

    getType(value) {
      // 获取证件类型
      const item = COMPANY_TYPE_LIST.find((item) => item.value === value);
      return item?.label || "";
    },

    loadMorePage(page) {
      this.searchCompany(page);
    },

    setVisible(v) {
      this.visible = v;
    },

    goBack() {
      this.$router.push("/user/certification");
    },
  },
  created() {
    this.searchCompany();
  },
};
</script>

<style lang="scss" module scoped>
.page {
  min-height: 300px;
  padding: rem(50);
  padding-top: rem(10);
  background: $white;

  :global {
    .gl-title {
      margin-bottom: rem(20);
    }

    .gl-row {
      padding-bottom: rem(40);
    }

    .gl-item {
      margin-right: rem(30);
    }

    .el-input {
      width: rem(300);
    }

    .el-pagination {
      @include flex();
      margin-top: rem(50);
    }
  }

  .action_btn {
    cursor: pointer;
    &:hover {
      color: $theme-color;
    }
  }

  .goBack {
    padding: 5px;
    font-size: rem(14);
    color: #333;
    cursor: pointer;
    &:hover {
      color: $theme-color;
    }
  }
}
</style>
